module.exports = __webpack_public_path__ + "static/media/building-1.a7880024.svg";